module.exports = __webpack_public_path__ + "img/CGD_T-6000.efdbf007.png";